import axios from 'axios';

const authTokenSet = (token: any) => {
	if (token) {
		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	} else {
		console.log(' false call authTokenSet', false);
		delete axios.defaults.headers.common['Authorization'];
	}
};

export default authTokenSet;
